// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1yt41b66{padding:var(--ds-space-050,4px)}._1e0c116y{display:inline-flex}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/media-type-icon-compiled.compiled.css"],"names":[],"mappings":";AACA,WAAW,+BAA+B,CAAC,WAAW,mBAAmB","sourcesContent":["\n._1yt41b66{padding:var(--ds-space-050,4px)}._1e0c116y{display:inline-flex}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
